import React, { useState, useEffect } from 'react';
import { getTimezoneFromLocation } from 'FielderUtils/location/location';
import { GOOGLE_API_KEY } from 'FielderUtils/session/Session';
import GoogleMapsAutocomplete from '~/GoogleMapsAutocomplete/GoogleMapsAutocomplete.component';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from 'react-redux';
import { selectCenter } from '../../core/store/modules/map/mapSelectors';
import { setZoom, setCenter, setRestartCenter, setRoute } from '../../core/store/modules/map/mapSlice';
import Map from '../Map/Map.component';
import LocationSearch from './components/LocationSearch';
import { MapContainer } from './styled';
import {
	setKey,
	fromLatLng,
	setLanguage
} from "react-geocode";
setKey(GOOGLE_API_KEY);
setLanguage('en');
const EMPTY_LOCATION = {
	address: '',
	state: '',
	postalCode: '',
	country: '',
	timezone: '',
};
const getGeocode = async (coords) => {
	if (!coords) return null;
	const location = await fromLatLng(coords.lat, coords.lng);
	return location.results[0];
};
const handleNewLocation = async (place, coords) => {
	const newLocation = {};

	newLocation.timezone = await getTimezoneFromLocation(coords.lat, coords.lng);
	newLocation.address = place.formatted_address;

	place.address_components.forEach((addressComponent) => {
		const type = addressComponent.types[0];
	
		switch (type) {
			case 'administrative_area_level_1':
			newLocation.state = addressComponent.long_name;
			break;

			case 'administrative_area_level_2':
			case 'locality':
			case 'sublocality_level_1':
			newLocation.municipality = validateMunicipality(addressComponent);
			break;

			case 'country':
			newLocation.country = addressComponent.long_name;
			break;

			case 'postal_code':
			newLocation.postalCode = addressComponent.long_name;
			break;
		}
	});

	return newLocation;
};
const validateMunicipality = (addressComponent) => {
	if (addressComponent.types[0] === 'administrative_area_level_2' ) {
		return addressComponent.long_name;
	  } else if ( addressComponent.types[0] === 'locality') {
		return addressComponent.long_name;
	  } else if (addressComponent.types[0] === 'sublocality_level_1') {
		return addressComponent.long_name; 
	  }
}
const Location = (props) => {
	const {
		height,
		label,
		edit,
		locationInfo,
		coordinates,
		locationUpdate,
		error,
		includeCoordinates,
		showDirection,
		markers,
	} = props;

	const dispatch = useDispatch();
	const center = useSelector(selectCenter);
	const updateLocationFromCoords = async (coords) => {
		const geocodeLocation = await getGeocode(coords);
		if (geocodeLocation !== null) {
			setMarker((m) => ({ ...m, marker: { position: { lat: coords.lat, lng: coords.lng } } }));
			const newLocation = await handleNewLocation(geocodeLocation, coords);
			setLocation(newLocation);
			dispatch(setCenter(coords));
		}
	};
	const [markersMap, setMarkersMap] = useState(markers);
	const [location, setLocation] = useState(EMPTY_LOCATION);
	const [marker, setMarker] = useState(null);
	useEffect(() => {
		if (locationInfo) return;
		if (markers && markers.length > 0) {
			setMarkersMap(markers);
      if(props.idBranchListArray && props.idBranchListArray.length > 0){
        setMarker(null);
      }
      return;
		} else {
			const markerData = {
				config: {
					draggable: edit,
					onDragEnd: updateLocationFromCoords,
				},
				marker: {
					position: {
						lat: 0,
						lng: 0,
					},
				},
			};

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const { latitude, longitude } = position.coords;
						markerData.marker.position.lat = latitude;
						markerData.marker.position.lng = longitude;
						setMarker(markerData);
					},
					() => {
						setMarker(markerData);
					}
				);
				setMarker(markerData);
			} else {
				setMarker(markerData);
			}
			setMarkersMap([]);
		}
	}, [markers]);

	useEffect(() => {
			if (props.idCompany ) {
				setLocation(EMPTY_LOCATION);
			}
			console.log(props.idCompany)

	}, [props.idCompany]);
	useEffect(() => {
			if ( props.idBranchListArray) {
				setLocation(EMPTY_LOCATION);
			}

			console.log(props.idBranchListArray)
	}, [ props.idBranchListArray]);

	useEffect(() => {
		if (markers && markers.length > 0 && marker != null) {
			setMarker(null);
		}
	}, [marker]);
	useEffect(() => {
		dispatch(setRoute(null));
		if (!locationInfo) {
			dispatch(setRestartCenter());
			dispatch(setZoom(2));
		} else {
			const coords = {
				lat: parseFloat(locationInfo.lat),
				lng: parseFloat(locationInfo.lng),
			};

			dispatch(setCenter(coords));
			setMarker((m) => ({ ...m, marker: { position: coords } }));

			let address = '';
			if (locationInfo.newDirection) {
				address = locationInfo.newDirection;
			} else if (locationInfo.address) {
				address = locationInfo.address;
			}

			setLocation({
				address,
				state: locationInfo.state,
				postalCode: locationInfo.postalCode,
				country: locationInfo.country,
				timezone: locationInfo.timezone ? locationInfo.timezone : locationInfo.timeZone,
			});
		}
	}, [locationInfo]);
	const locationUpdateFromCoordinates = async (location) => {
		const geocodeLocation = await getGeocode(location.coordinates);
		if (geocodeLocation !== null) {
			const completeLocation = await handleNewLocation(geocodeLocation, location.coordinates);
			locationUpdate(completeLocation, marker.marker.position)
		}
	};
	useEffect(() => {
		if ('address' in location && location.address !== '') {
			if (marker && marker.marker) {
				locationUpdate(location, marker.marker.position);
			}
		} else {
			locationUpdateFromCoordinates(location);
		}
	}, [location]);
	useEffect(() => {
		setMarker((m) => ({
			...m,
			config: {
				draggable: edit,
				onDragEnd: updateLocationFromCoords,
			},
		}));
	}, [edit]);
	useEffect(() => {
		if (coordinates && parseFloat(coordinates.lat) !== 0 && parseFloat(coordinates.lng) !== 0) {
			dispatch(
				setCenter({
					lat: parseFloat(coordinates.lat),
					lng: parseFloat(coordinates.lng),
				})
			);
			// dispatch(setZoom(15));
		}
	}, [coordinates]);
	const selectLocation = async (location) => {
		console.log('selectLocation: ', location);
		if (location) {
			const { coordinates } = location;
			setMarker((m) => ({ ...m, marker: { position: { lat: coordinates.lat, lng: coordinates.lng } } }));
			location.timezone = await getTimezoneFromLocation(coordinates.lat, coordinates.lng);
			setLocation(location);
			dispatch(setCenter(coordinates));
		} else {
			locationUpdate(EMPTY_LOCATION, { lat: 0, lng: 0 });
		}
	};
	return (
		<Grid container>
			<Grid size={12} className='mb-4'>
				<MapContainer height={height}>
					<Map marker={marker} markers={markersMap} />
				</MapContainer>
			</Grid>
			{includeCoordinates && showDirection === false && (
				<Grid size={12} className='branch-label-input'>
					{label}
				</Grid>
			)}
			<Grid size={12}>
				{includeCoordinates ? (
					<LocationSearch
						address={location.address}
						selectLocation={selectLocation}
						disabled={!edit}
						label={label}
						error={error}
						coordinates={center}
					/>
				) : showDirection === false ? (
					<GoogleMapsAutocomplete
						id='branch-googleMapsAutocomplete'
						value={location.address}
						onSelect={selectLocation}
						disabled={!edit}
						label={label}
						error={error}
					/>
				) : null}
			</Grid>
		</Grid>
	);
};
export default Location;
